import { trie } from '../cantoneseTrie';

/** Longest dictionary match, preserving complete Unicode code points in fallback text. */
const segment = (inputText: string, dictionaryTrie = trie): string => {
    const chunks: string[] = [];
    let offset = 0;
    while (offset < inputText.length) {
        const match = dictionaryTrie.longestMatch(inputText, offset);
        if (match) {
            chunks.push(match);
            offset += match.length;
            continue;
        }
        const point = String.fromCodePoint(inputText.codePointAt(offset) as number);
        let chunk = point;
        offset += point.length;
        // Preserve the legacy grouping of Latin text, digits, and spaces.
        if (/^[ -'*-~]$/.test(point)) {
            while (offset < inputText.length && /^[ -'*-~]$/.test(inputText[offset])) {
                chunk += inputText[offset];
                offset += 1;
            }
        }
        chunks.push(chunk);
    }
    return chunks.length ? ` ${chunks.join(' ')}`.replace(/\n /g, '\n') : '';
};

export default segment;
